import { AiFillEye } from "react-icons/ai";
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllEnquiries } from "../../../redux/actions/authActions"; 
import SearchBar from "../../../components/searchbar/SearchBar";

const EnquiresHome = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const enquiries = useSelector((state) => state.auth.allEnquiries);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (token) {
      dispatch(getAllEnquiries());
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (enquiries && Array.isArray(enquiries)) {
      setRows(enquiries);
    }
  }, [enquiries]);

  const handleSearch = (searchTerm) => {
    if (!searchTerm) {
      setRows(enquiries);
      return;
    }
    const filteredRows = enquiries.filter((r) =>
      r.companyName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      r.clientName?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setRows(filteredRows);
  };

  const columns = [
    { 
      field: "companyName", 
      headerName: "Company Name", 
      width: 200,
      renderCell: (params) => <span className="font-medium text-gray-900">{params.value || "N/A"}</span>
    },
    { field: "clientName", headerName: "Contact Person", width: 180 },
    { field: "emailAddress", headerName: "Email", width: 220 },
    {
      field: "createdAt",
      headerName: "Enquiry Date",
      width: 150,
      renderCell: (params) => {
        return <span>{params.value ? new Date(params.value).toLocaleDateString('en-GB') : "N/A"}</span>;
      },
    },
    {
      field: "view",
      headerName: "Action",
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <button
          className="bg-white p-2 rounded-full text-blue-600 border border-gray-200 shadow-sm hover:bg-blue-50 transition-colors"
          onClick={() => navigate(`/enquires/view-enquiry/${params.row._id}`)}
        >
          <AiFillEye size={18} />
        </button>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <SearchBar titleOne="Add Enquiry" onSearch={handleSearch} addClientPath="/enquires/add-enquiry" showAddButton={true} />
      <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
        <div style={{ width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row._id}
            pageSizeOptions={[5, 8, 10, 25]}
            initialState={{
              pagination: { paginationModel: { pageSize: 8, page: 0 } },
              sorting: { sortModel: [{ field: 'createdAt', sort: 'desc' }] },
            }}
            disableRowSelectionOnClick
          />
        </div>
      </div>
    </div>
  );
};

export default EnquiresHome;